import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import styles from "./Panel.module.css";

type PanelProps = PropsWithChildren<{
  visible?: boolean;
  withBorder?: boolean;
  padding?: {
    top?: boolean;
    bottom?: boolean;
    left?: boolean;
    right?: boolean;
  };
  isDragging?: boolean;
}>;

const Panel: FC<PanelProps> = ({
  children,
  visible = true,
  withBorder = true,
  padding = {
    top: true,
    bottom: true,
    left: true,
    right: true,
  },
  isDragging = false,
}: PanelProps) => (
  <div
    className={classNames(styles.panel, {
      [styles.hidden]: !visible,
      [styles.scroll]: !withBorder,
      [styles.paddingBottom]: padding.bottom,
      [styles.paddingTop]: padding.top,
      [styles.paddingRight]: padding.right,
      [styles.paddingLeft]: padding.left,
    })}
  >
    {withBorder ? (
      <div className={classNames(styles.border, { [styles.dragged]: isDragging })}>
        <div className={styles.scroller}>{children}</div>
      </div>
    ) : (
      children
    )}
  </div>
);

export default Panel;
